export const translationConnectAi_en = {
  pageTitle: "Connect your AI tools",
  pageDescription:
    "Connect Claude, Codex and other AI tools directly to your chatbot data via MCP. You sign in with your regular dashboard account — the AI tool can do exactly what you can do in the dashboard.",

  serverUrlLabel: "MCP server URL",
  copy: "Copy",
  copied: "Copied",
  copyTooltip: "Copy to clipboard",

  capabilitiesTitle: "What can you use it for?",
  capabilitiesDescription:
    "Once connected, an AI tool can work directly with your data — for example updating the knowledge base, analyzing conversations or pulling statistics while you chat with it.",
  capabilityWorkspaceTitle: "Workspace",
  capabilityWorkspaceDescription:
    "See your chatbots and knowledge bases so the AI tool knows what it is working with.",
  capabilityRulesTitle: "Behavior rules",
  capabilityRulesDescription:
    "Read, create, edit and delete rules — including scheduled rules (e.g. campaigns for a specific period).",
  capabilityKnowledgeTitle: "Knowledge base",
  capabilityKnowledgeDescription:
    "Read, add and update knowledge-base content. Changes are used by the chatbot immediately.",
  capabilityConversationsTitle: "Conversations",
  capabilityConversationsDescription:
    "Find and read conversations, flag issues, add comments and export conversations for analysis.",
  capabilityTestConversationsTitle: "Test conversations",
  capabilityTestConversationsDescription:
    "Have test conversations with your chatbot exactly as a visitor in the chat widget, starting with its start message. Saved as test conversations, with a small hourly and daily limit.",
  capabilityStatisticsTitle: "Statistics",
  capabilityStatisticsDescription:
    "Pull reports on messages, ratings, topics, purchases, livechat and response times.",

  connectTitle: "How to connect",
  connectDescription:
    "Pick the tool you use. The first time, you will be asked to sign in with your dashboard account and approve the access.",

  clientClaudeTitle: "Claude & Claude Cowork",
  clientClaudeDescription: "claude.ai, Claude Desktop and Cowork — added as a connector.",
  clientClaudeButton: "Open Claude connectors",
  clientClaudeStep1: "Click the button — it opens Settings → Connectors on claude.ai.",
  clientClaudeStep2: "Choose “Add custom connector” and paste the server URL above.",
  clientClaudeStep3: "Sign in with your dashboard account and approve the access.",

  clientClaudeCodeTitle: "Claude Code",
  clientClaudeCodeDescription: "Anthropic's coding agent in the terminal.",
  clientClaudeCodeStep1:
    "Run the command in your terminal. It uses a fixed callback port, so keep port 8080 free while you sign in:",
  clientClaudeCodeStep2: "Then type /mcp in Claude Code to sign in.",

  clientCodexTitle: "Codex",
  clientCodexDescription: "OpenAI's coding agent (CLI and IDE extension).",
  clientCodexStep1: "Run the command in your terminal:",
  clientCodexStep2: "Then sign in with:",

  clientCursorTitle: "Cursor",
  clientCursorDescription: "AI code editor — supports one-click install.",
  clientCursorButton: "Add to Cursor",
  clientCursorStep1: "Click the button (requires Cursor installed) and approve the server.",
  clientCursorStep2: "Sign in with your dashboard account when Cursor asks.",

  clientVsCodeTitle: "VS Code",
  clientVsCodeDescription: "GitHub Copilot in VS Code — one-click install.",
  clientVsCodeButton: "Add to VS Code",
  clientVsCodeStep1: "Click the button (requires VS Code installed) and confirm.",
  clientVsCodeStep2: "Start the server in VS Code and sign in with your dashboard account.",

  clientOtherTitle: "Other MCP clients",
  clientOtherDescription:
    "Any tool that supports remote MCP servers (Streamable HTTP + OAuth) can connect — e.g. ChatGPT (developer mode) or MCP Inspector.",
  clientOtherStep1: "Add a remote MCP server using the URL above.",
  clientOtherStep2: "Complete the OAuth sign-in flow with your dashboard account.",

  firstToolHint:
    "Tip: Ask the AI tool to call get_workspace first — that tells it about your chatbots and knowledge bases.",

  securityTitle: "Security and access",
  securityBody:
    "Each user signs in with their own dashboard account, and the AI tool gets exactly the permissions that user has in the dashboard — no more, no less. Read-only roles cannot make changes via MCP, and access can always be revoked by removing the user from the organization.",
};
